import { useState, useEffect } from 'react'
import { ExpiryEffectivityDate } from '@src/common/DatePicker';
import DocumentGallery from './DocumentGallery';
import { fetchLeadData, updateLeadDetailsInStore,savePaymentInfo,savePaymentIncentiveInfo } from '@src/store/slices/insurance';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import DocumentForm from "../detail/inbound-outbound-payment/Documents";
import FullPageLoader from '@common/FullPageLoader';
import { DOCUMENT_CATEGORY, ROLE_FEATURES, API_TYPES, FORM_SOW_TYPE,PAYMENT_TYPE_INBOUND,PAYMENT_TYPE_FROM_CUSTOMER_TO_BROKER,PAYMENT_DONE_PREMIUN, INS_INSURANCE_ID_STAGE, STATUS_SUCCESS, LEAD_TYPE_CRM } from "@src/config/constant";
import LeadRemarksButton from '../common/LeadRemarksButton';
import * as HELPER from "../../../config/helper";
import ReactSelect from '@common/ReactSelect';
import { getMasterConfig,getDocumentListing } from '@src/store/slices/common'
import { useLanguage } from '@src/context/LanguageContext';
import { LEAD_DETAIL_AMOUNT_FIELDS } from '@src/config/id/constant';
import { COUNTRY_CODE } from '@src/config/constant';

// Define the structure of error fields for validation
type ErrFieldState = {
    insPolicyNumber: string;
    InsPolicyGenerateDate: string;
    expiry_date: string;
    effectivity_date: string,
    grossWrittenPremium: string,
    customerDiscountPercent: string,
    customerDiscountValue: string,
    agentCommissionPercent: string,
    agentCommissionValue: string,
    insurancePremiumAmount: string,
    premiumExcludingAgentCommission: string,
    totalPremiumAmountReceived: string,
    excessAmountWithOTO: string,
    paymentMethod: string,
    premiumPaidDate: string,
    paymentReferenceNo: string,
    transactionFeePaidByCustomer: string,
    paymentTo:string,
    commission: string,
    commissionValue:string,
    points:string,
    pointsValue:string,
    taxCommission:string,
    netCommissionDisbursal:string,
    customerToPartnerDocument:string,
    paymentDestination: string;
    isPayment:string;
    earningsPaymentDate: string;
    transferFee:string;
    cash_customer_per: string,
    cash_customer: string,
    gross_profit: string
};


const InsurancePremiumPayment = (props: any) => {
    
    const [formInputs, setFormInputs] = useState({
        payment_id:"",
        grossWrittenPremium: "",
        customerDiscountPercent: "",
        customerDiscountValue: "",
        agentCommissionPercent: "",
        agentCommissionValue: "",
        insurancePremiumAmount: "",
        premiumExcludingAgentCommission: "",
        totalPremiumAmountReceived: "",
        excessAmountWithOTO: "",
        paymentMethod: "",
        premiumPaidDate: "",
        paymentReferenceNo: "",
        transactionFeePaidByCustomer: "",
        commission: "25",
        commissionValue:"100",
        points:"",
        pointsValue:"",
        taxCommission:"",
        netCommissionDisbursal:"1500",
        cus_taxcommission:"",
        cus_netcommissiondisbursal:"",
        paymentDestination: {value: 1, label: 'OTO'},
        isPayment:"",
        earningsPaymentDate: "",
        transferFee: "",
        cash_customer_per: '',
        cash_customer: '',
        gross_profit: ''
    });

    const [errField, setErrField] = useState<ErrFieldState>({
        insPolicyNumber: "",
        InsPolicyGenerateDate: "",
        expiry_date: "",
        effectivity_date: "",
        grossWrittenPremium: "",
        customerDiscountPercent: "",
        customerDiscountValue: "",
        agentCommissionPercent: "",
        agentCommissionValue: "",
        insurancePremiumAmount: "",
        premiumExcludingAgentCommission: "",
        totalPremiumAmountReceived: "",
        excessAmountWithOTO: "",
        paymentMethod: "",
        premiumPaidDate: "",
        paymentReferenceNo: "",
        transactionFeePaidByCustomer: "",
        paymentTo:"",
        commission: "",
        commissionValue:"",
        points:"",
        pointsValue:"",
        taxCommission:"",
        netCommissionDisbursal:"",
        customerToPartnerDocument:"",
        paymentDestination: "",
        isPayment:"",
        earningsPaymentDate: "",
        transferFee:"",
        cash_customer_per: '',
        cash_customer: '',
        gross_profit: ''
    });

    let [loading, setLoading] = useState<boolean>(false);
    
    // Redux hooks to dispatch actions and access state
    const dispatch: any = useDispatch()
    const insuranceState = useSelector((state: any) => state.insurance)

    const navigate = useNavigate();
    const queryParams: any = useParams();

    const formType = props.formType;

    const [formShowType, setFormShowType] = useState<any>(null)

    const [paymentTo, setPaymentTo] = useState<any>([
        {
            label : "Customer",
            value : 1,
        },
        {
            label : "Agent",
            value : 2,
        }
    ]);

    const [paymentMethods, setPaymentMethods] = useState<any>([]);

    const [submitClicked, setSubmitClicked] = useState<boolean>(false);
    const [leadDetails, setLeadDetails] = useState<any>({});

    const [filesCount, setFilesCount] = useState<number>(0);

    let [apiCallFlag, setApiCallFlag] = useState(false);

    const commonState = useSelector((state: any) => state.common);

    const {translations} = useLanguage();
    const [paymentDestinations, setPaymentDestinations] = useState<any>([]);
    const [isPayments, setIsPayments] = useState<any>([
        {
            label : "Yes",
            value : 1,
        },
        {
            label : "No",
            value : 2,
        }
    ]);

    useEffect(() => { 
        setPaymentTo([
            {
                label: translations.Insurance?.['Customer'] || translations?.commonMsg?.loading,
                value: 1,
            },
            {
                label: translations.Insurance?.['Agent'] || translations?.commonMsg?.loading,
                value: 2,
            }
        ]);

        setIsPayments([
            {
                label: translations.commonMsg?.['Yes'] || translations?.commonMsg?.loading,
                value: 1,
            },
            {
                label: translations.commonMsg?.['No'] || translations?.commonMsg?.loading,
                value: 2,
            }
        ]);
        
        setApiCallFlag(false)
        if (formShowType?.label) {
            const updatedLabel = translations.Insurance?.[formShowType.label] || translations?.commonMsg?.loading;
            setFormShowType((prev:any) => ({
                ...prev,
                label: updatedLabel,
            }));
        }
        // eslint-disable-next-line
    }, [translations,setApiCallFlag]);


    // Function to handle changes in input fields
    const onChangeHandler = (value: any, type: any) => { 
        setFormInputs((prev) => {
            // Ensure empty input correctly updates the state
            const updatedState = { 
                ...prev, 
                [type]: value === "" ? "" : value 
            };
            if (type === "totalPremiumAmountReceived" && value !== "") {
                // if(COUNTRY_CODE === 'id'){
                //     (updatedState.excessAmountWithOTO as any) = HELPER.removeCurrencyFormattingId(updatedState.excessAmountWithOTO);
                // }
                if(+formShowType.value === 1){
                    updatedState.excessAmountWithOTO = (parseFloat(value) - insuranceState.leadDetail.final_premium).toFixed(0);
                }else{ 
                    // if(COUNTRY_CODE === 'id'){
                    //     (formInputs.premiumExcludingAgentCommission as any) = HELPER.removeCurrencyFormattingId(formInputs.premiumExcludingAgentCommission);
                    // }
                    updatedState.excessAmountWithOTO = ( parseFloat(value) - parseFloat(formInputs.premiumExcludingAgentCommission) ).toFixed(0);
                }
                // if(COUNTRY_CODE === 'id'){
                //     updatedState.excessAmountWithOTO = HELPER.addCurrencyFormatting(updatedState.excessAmountWithOTO);
                // }
                
            }
            return updatedState;
        });
        setErrField((prev) => ({
            ...prev,
            [type]: "",
        }));
    };
    

    const onChangeFormType = (value:any, type:any) => { 
        let receivedValue = +formInputs?.totalPremiumAmountReceived || 0;
        let insurancePremiumAmount =  +formInputs?.insurancePremiumAmount || 0; 

        let excessAmountWithOTO:any = 0;
        if(value?.value === 2){
            let exludeAmt = +formInputs?.premiumExcludingAgentCommission || 0;  
            excessAmountWithOTO = receivedValue - exludeAmt; 
        }else{
            excessAmountWithOTO = receivedValue - insurancePremiumAmount; 
        } 
        setFormInputs({
            ...formInputs,
            excessAmountWithOTO:  excessAmountWithOTO

        })
        setFormShowType(value);
    }

    // Validate the form fields before submitting
    const validForm = () => {
        let formIsValid = true;
        setErrField((prevState) => ({
            ...prevState,
            effectivity_date: "",
            grossWrittenPremium: "",
            customerDiscountPercent: "",
            customerDiscountValue: "",
            agentCommissionPercent: "",
            agentCommissionValue: "",
            insurancePremiumAmount: "",
            premiumExcludingAgentCommission: "",
            totalPremiumAmountReceived: "",
            excessAmountWithOTO: "",
            paymentMethod: "",
            premiumPaidDate: "",
            paymentReferenceNo: "",
            transactionFeePaidByCustomer: "",
            paymentTo:"",
            commission: "",
            commissionValue:"",
            points:"",
            pointsValue:"",
            taxCommission:"",
            netCommissionDisbursal:"",
            customerToPartnerDocument:"",
            isPayment: "",
        }));
        const errors: any = {};
        // Validation Rules
        if(!formShowType){
            errors.paymentTo = "Payment To is Required.";
            formIsValid = false;
        }
        if(formType === "insurance-premium-payment"){
            // if (!formInputs.grossWrittenPremium || isNaN(+formInputs.grossWrittenPremium) || +formInputs.grossWrittenPremium <= 0) {
            //     errors.grossWrittenPremium = "Gross Written Premium must be a valid positive number.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.customerDiscountPercent || isNaN(+formInputs.customerDiscountPercent)) {
            //     errors.customerDiscountPercent = "Customer Discount Percent must be a valid number.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.customerDiscountValue || isNaN(+formInputs.customerDiscountValue)) {
            //     errors.customerDiscountValue = "Customer Discount Value must be a valid number.";
            //     formIsValid = false;
            // }
    
            // if(formShowType.value === FORM_SOW_TYPE['AGENCT']){
            //     if (!formInputs.agentCommissionPercent || isNaN(+formInputs.agentCommissionPercent)) {
            //         errors.agentCommissionPercent = "Agent Commission Percent must be a valid number.";
            //         formIsValid = false;
            //     }
        
            //     if (!formInputs.agentCommissionValue || isNaN(+formInputs.agentCommissionValue)) {
            //         errors.agentCommissionValue = "Agent Commission Value must be a valid number.";
            //         formIsValid = false;
            //     }

            //     if (!formInputs.premiumExcludingAgentCommission || formInputs.premiumExcludingAgentCommission.trim() === "") {
            //         errors.premiumExcludingAgentCommission = "Premium Amount Excluding Agent Commission is required.";
            //         formIsValid = false;
            //     }
            // }
    
            // if (!formInputs.insurancePremiumAmount || isNaN(+formInputs.insurancePremiumAmount) || +formInputs.insurancePremiumAmount <= 0) {
            //     errors.insurancePremiumAmount = "Insurance Premium Amount must be a valid positive number.";
            //     formIsValid = false;
            // }

        
            if (filesCount === 0) {
                errors.customerToPartnerDocument = "At least one file is required.";
                formIsValid = false;
            }
            if (filesCount > 2) {
                errors.customerToPartnerDocument = "You can only upload up to 2 files.";
                formIsValid = false;
            }
            
            // (formInputs.totalPremiumAmountReceived as any) = HELPER.removeCurrencyFormattingId(formInputs.totalPremiumAmountReceived);
    
            if (!formInputs.totalPremiumAmountReceived || isNaN(+formInputs.totalPremiumAmountReceived) || +formInputs.totalPremiumAmountReceived <= 0) {
                errors.totalPremiumAmountReceived = "This field is required.";
                formIsValid = false;
            }
    
            if (!formInputs.paymentMethod) {
                errors.paymentMethod = "Payment Method is required.";
                formIsValid = false;
            }
    
            if (!formInputs.premiumPaidDate) {
                errors.premiumPaidDate = "Premium Paid Date is required.";
                formIsValid = false;
            }

            if (!formInputs.isPayment) {
                errors.isPayment = "Is Payment Done is required.";
                formIsValid = false;
            }

            // if (!formInputs.paymentReferenceNo || formInputs.paymentReferenceNo.trim() === "") {
            //     errors.paymentReferenceNo = "Payment Reference Number is required.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.excessAmountWithOTO || formInputs.excessAmountWithOTO.trim() === "") {
            //     errors.excessAmountWithOTO = "Transaction Fee Paid by customer is required.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.transactionFeePaidByCustomer || formInputs.transactionFeePaidByCustomer.trim() === "") {
            //     errors.transactionFeePaidByCustomer = "Transaction Fee Paid by customer is required.";
            //     formIsValid = false;
            // }

        }

        if(formType === "incentive-payment"){ 
    
            // if (!formInputs.points || formInputs.points.trim() === "") {
            //     errors.points = "Points is required.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.pointsValue || formInputs.pointsValue.trim() === "") {
            //     errors.pointsValue = "Points Value is required.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.taxCommission || formInputs.taxCommission.trim() === "") {
            //     errors.taxCommission = "Tax Commission is required.";
            //     formIsValid = false;
            // }
    
            // if (!formInputs.netCommissionDisbursal || formInputs.netCommissionDisbursal.trim() === "") {
            //     errors.netCommissionDisbursal = "Net Commission Disbursal is required.";
            //     formIsValid = false;
            // }
            if ((!formInputs.transferFee || formInputs.transferFee === null || formInputs.transferFee === undefined) && COUNTRY_CODE === 'id') {
                errors.transferFee =  translations.Insurance?.['Bank transfer fees is required'] 
                formIsValid = false;
            }

            if ((!formInputs.earningsPaymentDate) && COUNTRY_CODE === 'id') {
                errors.earningsPaymentDate =  translations.Insurance?.['Earnings payments is required']
                formIsValid = false;
            }
        }


        // Apply errors
        setErrField((prevState) => ({
            ...prevState,
            ...errors,
        }));

        return formIsValid;
    };



    // Redirect to the next page after successful update
    const nextPageRedirect = () => {

        if (formType === 'insurance-policy-generated') {
            navigate(`/details/insurance-policy-shared/${queryParams.id}`);
        }
        // if (formType === 'soft-approval-received') {
        //     navigate(`/details/insurance-policy-generated/${queryParams.id}`);
        // }

    }


    //  Fetch insurance details when the component mounts  - type 2 is for Insurance Policy Generated
    useEffect(() => {
        if (insuranceState && insuranceState.leadDetail) {
            if (['incentive-payment','insurance-premium-payment'].includes(formType)) {
                let paymentMade = formShowType?.value || insuranceState.leadDetail.inbound_payment_from;
                const selectedPayment = paymentTo.find((item:any) => item.value === paymentMade) || null;
                setFormShowType(selectedPayment);
                setFormInputs((prevState: any) => {
                    const updatedState = { ...prevState };
                    const selectPaymentMEthod = paymentMethods?.find((item:any) => item.value === insuranceState.leadDetail.inbound_payment_comming_from) || null;
                    updatedState.paymentMethod = selectPaymentMEthod

                    updatedState.paymentDestination = insuranceState.leadDetail?.inbound_payment_destination ? paymentDestinations?.find((item:any) => item.value === insuranceState.leadDetail.inbound_payment_destination) : formInputs.paymentDestination;
                    updatedState.isPayment = isPayments?.find((item:any) => +item.value === +insuranceState.leadDetail.inbound_is_payment) || null;


                    updatedState.commission = insuranceState.leadDetail.agent_commision;
                    updatedState.commissionValue = insuranceState.leadDetail.agent_comission_amount;
 
                    updatedState.cus_taxcommission = insuranceState.leadDetail.agent_tax_commission;
                    updatedState.cus_netcommissiondisbursal = insuranceState.leadDetail.agent_net_commission_disbursal;

                    updatedState.points = insuranceState.leadDetail.point_commision;
                    updatedState.pointsValue = insuranceState.leadDetail.agent_point_amount;
 
                    updatedState.taxCommission = insuranceState.leadDetail.point_tax_commission;
                    updatedState.netCommissionDisbursal = insuranceState.leadDetail.point_net_commission_disbursal; 
                    updatedState.gross_profit = insuranceState.leadDetail.gross_profit || ''
                    updatedState.cash_customer_per = insuranceState.leadDetail?.cash_customer_per?.toString() || ''
                    updatedState.cash_customer = insuranceState.leadDetail.cash_customer || ''


                    updatedState.grossWrittenPremium = insuranceState.leadDetail.gwp_amount || '';
                    updatedState.insurancePremiumAmount = insuranceState.leadDetail.final_premium || '';
                    updatedState.payment_id = insuranceState.leadDetail.inbound_id || '';
                    updatedState.premiumPaidDate = insuranceState.leadDetail.inbound_date ? new Date(insuranceState.leadDetail.inbound_date) : null
                    updatedState.paymentReferenceNo = insuranceState.leadDetail.inbound_payment_reference_number || '';
                    updatedState.totalPremiumAmountReceived =  insuranceState.leadDetail.inbound_amount || '';
                    updatedState.transactionFeePaidByCustomer = insuranceState.leadDetail.inbound_transaction_fee || ''

                    let agentExlcudeAmt = +insuranceState.leadDetail.gwp_amount - +insuranceState.leadDetail.customer_discount - +insuranceState.leadDetail.agent_comission_amount ;
                    updatedState.premiumExcludingAgentCommission = agentExlcudeAmt

                    if(+paymentMade === 2){
                        updatedState.excessAmountWithOTO = Math.round(insuranceState.leadDetail.inbound_amount-agentExlcudeAmt) 
                    }else{
                        updatedState.excessAmountWithOTO = Math.round(insuranceState.leadDetail.inbound_amount-insuranceState.leadDetail.final_premium) 
                    }
                    updatedState.customerDiscountPercent = insuranceState.leadDetail.customer_discount_per || ''
                    updatedState.customerDiscountValue = insuranceState.leadDetail.customer_discount || ''
                    updatedState.agentCommissionPercent = insuranceState.leadDetail.agent_commision ;
                    updatedState.agentCommissionValue = insuranceState.leadDetail.agent_comission_amount || ''
                    updatedState.earningsPaymentDate = insuranceState.leadDetail.earnings_payment_date ? new Date(insuranceState.leadDetail.earnings_payment_date) : null
                    updatedState.transferFee = insuranceState.leadDetail.transfer_fee || ''

                    // if(COUNTRY_CODE === 'id'){

                    //     for (let key in updatedState) {
                    //         if (LEAD_DETAIL_AMOUNT_FIELDS?.includes(key) && updatedState[key]) {
                    //             updatedState[key] = HELPER.addCurrencyFormatting(updatedState[key]);
                    //         }
                    //     }
                    // }
                 
                    return updatedState;
                });
            }
            setErrField((prev)=>({
                ...prev,
                InsPolicyGenerateDate:"",
                insPolicyNumber: "",
                expiry_date: "",
                effectivity_date: ""
            }));
        }
        // eslint-disable-next-line
    }, [formType, insuranceState,paymentMethods]);


    useEffect(() => {        
        if (formType && insuranceState.leadDetail.customer_api_call) {
            setLoading(true)
            let reqst: any = { lead_id: queryParams.id }
            let apiType = formType === 'soft-approval-received' ? API_TYPES['softApprovalData'] : API_TYPES['inboundData']
            
            fetchLeadData({ ...reqst, apiType,"payment_type": 1 }).then((res: any) => {
                if (res && res.data && Object.keys(res.data).length) {
                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }))
                }
            }).finally(() => setLoading(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formType, insuranceState.leadDetail.customer_api_call])


    const resolveFileUpload = (filesStatus: any) => {
        setLoading(false);

        if (filesStatus.status) {
            dispatch(updateLeadDetailsInStore({ ...leadDetails, images: [...leadDetails.images, ...filesStatus.data] }));
            nextPageRedirect();

        }

    }

    const updatedFileCount = (param:any) => {
        setFilesCount(param);
        setErrField((prev)=> ({...prev, policyDocument: ''}))
    }

    useEffect(() => {
        if (!apiCallFlag) {
            setApiCallFlag(true);            
            if (!commonState?.common?.payment_method?.length) {
                dispatch(getMasterConfig()).then((res: any) => {
                    if (res && res.status === STATUS_SUCCESS) {
                        setPaymentMethods(res.data.payment_method);
                        setPaymentDestinations(res.data.payment_destination);
                    }
                })
            }else{
                setPaymentMethods(commonState?.common?.payment_method)
                setPaymentDestinations(commonState?.common?.payment_destination)
            }
        }
    }, [dispatch, commonState, apiCallFlag]);

    // const pastSixMonths = new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate())

    const saveInsurancePremiumPayment = () => {
        setSubmitClicked(false);
        if(validForm()){
            if(formType === "insurance-premium-payment"){
                const payMethod:any = formInputs.paymentMethod;
                const paymentDestination:any = formInputs.paymentDestination;
                const isPayment:any = formInputs.isPayment;
                let date = new Date(formInputs.premiumPaidDate);
                let localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
                // if(COUNTRY_CODE === 'id'){
                //     (formInputs.transactionFeePaidByCustomer as any) = HELPER.removeCurrencyFormattingId(formInputs.transactionFeePaidByCustomer);
                // }
                let paymentInfoReq:any = { 
                    "lead_id": queryParams.id,
                    "payment_from":formShowType.value,
                    "payment_method":payMethod.value,
                    "payment_amount": formInputs.totalPremiumAmountReceived,
                    "transaction_fee": formInputs.transactionFeePaidByCustomer || "",
                    "payment_ref_no": formInputs.paymentReferenceNo || "",
                    "amount_date": localDate.toISOString().split("T")[0],
                    "payment_destination": paymentDestination.value,
                    "is_payment": isPayment.value,
                    "source":"web"
                }
                if(formInputs.payment_id){
                    paymentInfoReq['id'] = formInputs.payment_id;
                }
                setLoading(true);
                dispatch(savePaymentInfo(paymentInfoReq)).then((res: any) => {
                
                    if (res && res.status === STATUS_SUCCESS) {
                        toast.success(res.message);
                        if (res.data) {
    
                            let updatedState = {
                                ...insuranceState.leadDetail,
                                inbound_payment_comming_from: paymentInfoReq.payment_from,
                                inbound_payment_from: paymentInfoReq.payment_method,
                                inbound_id: paymentInfoReq.id,
                                inbound_date: paymentInfoReq.amount_date,
                                inbound_payment_reference_number: paymentInfoReq.payment_ref_no,
                                inbound_amount: paymentInfoReq.payment_amount,
                                inbound_transaction_fee: paymentInfoReq.transaction_fee,
                                inbound_payment_destination: paymentInfoReq.payment_destination,
                                inbound_is_payment: paymentInfoReq.is_payment,
                                ...res.data
                            };
                            dispatch(updateLeadDetailsInStore(updatedState));
                            setLeadDetails(updatedState);
    
                            if (res.data.installment_details) {
                                let updatedState = { ...insuranceState.leadDetail, ...res.data }
                                dispatch(updateLeadDetailsInStore(updatedState));
                                    // here with payload pass for fetching other details document
                                const payload:any = {
                                    leadId: props.leadHashId,
                                    source: 'web'
                                };

                                
                                //** Filter gate document images based on policyholder type, vehicle condition ID, existing policy, vehicle photos, and comments
                                if(INS_INSURANCE_ID_STAGE){
                                    payload.lead_id = insuranceState?.leadDetail?.id;
                                }
                                //** Filter gate document images based on policyholder type, vehicle condition ID, existing policy, vehicle photos, and comments
                                
                                dispatch(getDocumentListing(payload));
                            
                            }
    
                            if (+props.payment_type === PAYMENT_TYPE_INBOUND) { //INBOUNT PAYMENT
    
                                setSubmitClicked(true);
                            } else if (+props.payment_type === PAYMENT_TYPE_FROM_CUSTOMER_TO_BROKER) {
                                setSubmitClicked(true); //PAYMENT FROM CUSTOMER TO BROKER
                                const payload:any = {
                                    leadId: props.leadHashId,
                                    source: 'web'
                                };

                                if(INS_INSURANCE_ID_STAGE){        
                                    payload.lead_id = insuranceState?.leadDetail?.id;
                                }
                                
                                dispatch(getDocumentListing(payload)); //FOR UPDATING DOCUMENT LISIING
    
                            } else {
                                setSubmitClicked(true);
                                //FOR OUTBOUND SCREEN NAVIGATION HANDLING
                                setLoading(false);
    
                                dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }));
                            }
                            if(paymentInfoReq.is_payment === PAYMENT_DONE_PREMIUN){
                                navigate(`/details/incentive-payment/${insuranceState.leadDetail.hashId}`);
                            }
                        } else {
                            setLoading(false);
    
                        }
    
    
                    } else {
                        setLoading(false);
    
                    }
                    setErrField((prev) => Object.fromEntries(Object.keys(prev).map(key => [key, ""])) as ErrFieldState);
                }).catch((err: Error) => {
                    setLoading(false);
                })
            }else{
                // if(COUNTRY_CODE === 'id'){
                //     for (const key in formInputs) {
                //        if (LEAD_DETAIL_AMOUNT_FIELDS.includes(key as keyof typeof formInputs)) {
                //             const typedKey = key as keyof typeof formInputs;
                //             formInputs[typedKey] = HELPER.removeCurrencyFormattingId(formInputs[typedKey]) as any;
                //        }
                //     }
                // }
                let paymentIncentiveReq = {
                    "lead_id": queryParams.id,
                    "payment_from":formShowType.value,
                    "points":formInputs.points,
                    "points_value": formInputs.pointsValue,
                    "tax_commission": formInputs.taxCommission,
                    "net_commission_disbursal": formInputs.netCommissionDisbursal,
                    "cus_taxcommission": formInputs.cus_taxcommission,
                    "cus_netcommissiondisbursal": formInputs.cus_netcommissiondisbursal,
                    ...(formShowType.value === 1 && {
                        commission: formInputs.commission,
                        commsion_value: formInputs.commissionValue
                    }),
                    "transfer_fee": String(formInputs.transferFee || ""),
                    "earnings_payment_date": formInputs?.earningsPaymentDate || ""
                }
                setLoading(true);
                dispatch(savePaymentIncentiveInfo(paymentIncentiveReq)).then((res: any) => {
                
                    if (res && res.status === STATUS_SUCCESS) {
                        toast.success(res.message);
                        if (res.data) {
                            if (res.data && Object.keys(res.data).length) {
                                dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }));
                            }
                            setLeadDetails({ ...insuranceState.leadDetail, ...res.data });
                            setFormInputs((prevState: any) => ({
                                ...prevState,
                                ...(paymentIncentiveReq.payment_from === 1 && {
                                    commission: paymentIncentiveReq.commission,
                                    commissionValue: paymentIncentiveReq.commsion_value || '',
                                }),
                                points: paymentIncentiveReq.points,
                                pointsValue: paymentIncentiveReq.points_value,
                                taxCommission: paymentIncentiveReq.tax_commission,
                                netCommissionDisbursal: paymentIncentiveReq.net_commission_disbursal
                            }));
                            setLoading(false);
                        } else {
                            setLoading(false);
                        }
                        navigate(`/details/insurer-partner-payment/${insuranceState.leadDetail.hashId}`);
                    } else {
                        setLoading(false);
    
                    }
                    setErrField((prev) => Object.fromEntries(Object.keys(prev).map(key => [key, ""])) as ErrFieldState);
                }).catch((err: Error) => {
                    setLoading(false);
                })
            }
        }
    }
    
    const isCurrencyField = (key: string) => COUNTRY_CODE === 'id' && LEAD_DETAIL_AMOUNT_FIELDS.includes(key);
    const getNumericValue = (key: string, value: any) => isCurrencyField(key) ? HELPER.removeCurrencyFormattingId(value) : value;
    const getDisplayValue = (key: string, value: any) => isCurrencyField(key) ? HELPER.addCurrencyFormatting(value) : value ?? '';
   
      return (
        <div className="image-form-outer">
            <FullPageLoader show={loading} />
            <div className="image-tab-panel">
                <DocumentGallery formType={formType === 'insurance-premium-payment' ? 'insurance-premium-payment' : 'insurance-premium-payment'} payment_from={props.formType === 'insurance-premium-payment' ? 'insurance-premium-payment' : 'insurance-premium-payment'}/>
            </div>
            <div className="form-tab-right-panel wrapperPosition inspolicyshared">
                <div className="lead-detail-from-outer">
                    <div className="lead-form-heading">
                        <h2>
                            {formType === "soft-approval-received" ? "Soft Approval Received" :
                                formType === "insurance-premium-payment" ? `${translations.Insurance?.['Insurance Premium Payment'] || translations?.commonMsg?.loading}` :
                                formType === "incentive-payment" ? `${translations.Insurance?.['Incentive Payment'] || translations?.commonMsg?.loading}` :
                                    ""}
                        </h2>
                    </div>
                    <div className="lead-form-filed">
                        <div> 
                        {
                            insuranceState.leadDetail?.inbound_payment_user_name
                            ?
                                <span>
                                    <b>Payment Made by {insuranceState.leadDetail?.inbound_payment_user_role} </b>: {insuranceState.leadDetail?.inbound_payment_user_name}
                                </span>
                            :null
                        }
                        </div>
                        <br/>

                        <div className="row">
                            {formType === "insurance-premium-payment" && 
                                <>
                                    <ReactSelect options={paymentTo} 
                                        value={formShowType} 
                                        placeholder={`${translations.Insurance?.['Payment From'] || translations.commonMsg?.loading} *`}
                                        fieldKey="paymentTo"
                                        handleChange={(e: any, fieldKey: string) => onChangeFormType(e, fieldKey)} 
                                        errorField={errField.paymentTo}
                                        fieldSetClassName="col-md-12"
                                        isDisabled={
                                            !HELPER.isUserHasUpdateAccess({ 
                                                permissionID: (formType === 'insurance-premium-payment' 
                                                    ? ROLE_FEATURES['insurance_premium_payment'] 
                                                    : ROLE_FEATURES['incentive-payment']), 
                                                accessType: 'edit', 
                                                leadDetails: insuranceState.leadDetail, 
                                                pageSlug: formType 
                                            })
                                        }
                                    />
                                    {
                                        formShowType &&
                                        <>
                                            <ReactSelect options={paymentDestinations} 
                                                value={formInputs.paymentDestination} 
                                                placeholder={`${translations.Insurance?.['PAYMENT_MADE_TO'] || translations.commonMsg?.loading} *`}
                                                fieldKey="paymentDestination"
                                                handleChange={(e: any, fieldKey: string) => onChangeHandler(e, fieldKey)}
                                                errorField={errField.paymentDestination} 
                                                fieldSetClassName="col-md-6"
                                            />

                                            <ReactSelect options={isPayments} 
                                                value={formInputs.isPayment} 
                                                placeholder={`${translations.Insurance?.['IS_PAYMENT'] || translations.commonMsg?.loading} *`}
                                                fieldKey="isPayment"
                                                handleChange={(e: any, fieldKey: string) => onChangeHandler(e, fieldKey)}
                                                errorField={errField.isPayment} 
                                                fieldSetClassName="col-md-6"
                                            />
                                            
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.grossWrittenPremium}>
                                                    <input spellCheck={false} value={getDisplayValue('grossWrittenPremium', formInputs.grossWrittenPremium)} onChange={(e: any) => onChangeHandler(getNumericValue('grossWrittenPremium', e.target.value), 'grossWrittenPremium')} id="" type="text" placeholder=" " name="grossWrittenPremium" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Gross written Premium'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.grossWrittenPremium && (
                                                        <span className="error-txt">
                                                            {errField['grossWrittenPremium']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.customerDiscountPercent}>
                                                    <input value={formInputs.customerDiscountPercent} onChange={(e: any) => onChangeHandler(e.target.value, 'customerDiscountPercent')} id="" type="text" placeholder=" " name="customerDiscountPercent" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Customer Discount (%)'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.customerDiscountPercent && (
                                                        <span className="error-txt">
                                                            {errField['customerDiscountPercent']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.customerDiscountValue}>
                                                    <input spellCheck={false} value={getDisplayValue('customerDiscountValue',formInputs.customerDiscountValue)} onChange={(e: any) => onChangeHandler(getNumericValue('customerDiscountValue',e.target.value), 'customerDiscountValue')} id="" type="text" placeholder=" " name="customerDiscountValue" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Customer Discount Value'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.customerDiscountValue && (
                                                        <span className="error-txt">
                                                            {errField['customerDiscountValue']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            {
                                                formShowType.value === FORM_SOW_TYPE['AGENCT'] &&
                                                <>
                                                    <fieldset className="col-md-6">
                                                        <div className="material" title = {formInputs.agentCommissionPercent}>
                                                            <input spellCheck={false} value={formInputs.agentCommissionPercent} onChange={(e: any) => onChangeHandler(e.target.value, 'agentCommissionPercent')} id="" type="text" placeholder=" " name="agentCommissionPercent" className="form-input" disabled/>
                                                            <label data-label="Agent Commission (%) *" className="form-label"></label>
                                                            {errField.agentCommissionPercent && (
                                                                <span className="error-txt">
                                                                    {errField['agentCommissionPercent']}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </fieldset>
                                                    <fieldset className="col-md-6">
                                                        <div className="material" title = {formInputs.agentCommissionValue}>
                                                            <input spellCheck={false} value={getDisplayValue('agentCommissionValue',formInputs.agentCommissionValue)} onChange={(e: any) => onChangeHandler(getNumericValue('agentCommissionValue',e.target.value), 'agentCommissionValue')} id="" type="text" placeholder=" " name="agentCommissionValue" className="form-input" disabled/>
                                                            <label data-label="Agent Commission Value *" className="form-label"></label>
                                                            {errField.agentCommissionValue && (
                                                                <span className="error-txt">
                                                                    {errField['agentCommissionValue']}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </fieldset>
                                                </>
                                            }
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.insurancePremiumAmount}>
                                                    <input spellCheck={false} value={getDisplayValue('insurancePremiumAmount',formInputs.insurancePremiumAmount)} onChange={(e: any) => onChangeHandler(getNumericValue('insurancePremiumAmount',e.target.value), 'insurancePremiumAmount')} id="" type="text" placeholder=" " name="insurancePremiumAmount" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Insurance Premium Amount'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.insurancePremiumAmount && (
                                                        <span className="error-txt">
                                                            {errField['insurancePremiumAmount']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            {
                                                formShowType.value === FORM_SOW_TYPE['AGENCT'] &&
                                                <fieldset className="col-md-6">
                                                    <div className="material" title = "Premium Amount excluding Agent Commision">
                                                        <input spellCheck={false} value={getDisplayValue('premiumExcludingAgentCommission',formInputs.premiumExcludingAgentCommission)} onChange={(e: any) => onChangeHandler(getNumericValue('premiumExcludingAgentCommission',e.target.value), 'premiumExcludingAgentCommission')} id="" type="text" placeholder=" " name="premiumExcludingAgentCommission" className="form-input" disabled/>
                                                        <label data-label="Premium Amount excluding Agent Commision *" className="form-label label-txt"></label>
                                                        {errField.premiumExcludingAgentCommission && (
                                                            <span className="error-txt">
                                                                {errField['premiumExcludingAgentCommission']}
                                                            </span>
                                                        )}
                                                    </div>
                                                </fieldset>
                                            }   
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.totalPremiumAmountReceived}>
                                                    <input spellCheck={false} value={getDisplayValue('totalPremiumAmountReceived',formInputs.totalPremiumAmountReceived)} onChange={(e: any) => onChangeHandler(getNumericValue('totalPremiumAmountReceived',e.target.value),'totalPremiumAmountReceived')} id="" type="text" placeholder=" " name="totalPremiumAmountReceived" className="form-input" 
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                                            if (e.key === "e" || e.key === "E" || e.key === "." || e.key === "-") {
                                                                e.preventDefault();
                                                            }
                                                        }}/>
                                                    <label data-label= {`${translations.Insurance?.['Total Premium Amount Received'] || translations.commonMsg?.loading} *`}className="form-label"></label>
                                                    {errField.totalPremiumAmountReceived && (
                                                        <span className="error-txt">
                                                            {errField['totalPremiumAmountReceived']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.excessAmountWithOTO}>
                                                    <input spellCheck={false} value={getDisplayValue('excessAmountWithOTO',formInputs.excessAmountWithOTO)} onChange={(e: any) => onChangeHandler(getNumericValue('excessAmountWithOTO',e.target.value), 'excessAmountWithOTO')} id="" type="text" placeholder=" " name="excessAmountWithOTO" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Excess Amount With OTO'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.excessAmountWithOTO && (
                                                        <span className="error-txt">
                                                            {errField['excessAmountWithOTO']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <ReactSelect options={paymentMethods} 
                                                value={formInputs.paymentMethod} 
                                                placeholder={`${translations.Insurance?.['Payment Method'] || translations.commonMsg?.loading} *`}
                                                fieldKey="paymentMethod"
                                                handleChange={(e: any, fieldKey: string) => onChangeHandler(e, fieldKey)}
                                                errorField={errField.paymentMethod} 
                                                fieldSetClassName="col-md-6"/>
                                            <fieldset className="col-md-6">
                                                <div className={(formInputs?.premiumPaidDate) ? "active-label material animation-effect" : "material animation-effect "}>
                                                    <ExpiryEffectivityDate
                                                        onChange={(e: Date) => onChangeHandler(e, 'premiumPaidDate')}
                                                        placeholder=""
                                                        text={`${translations.Insurance?.['Premium Paid Date'] || translations.commonMsg?.loading} *`}
                                                        insurancePolicyDate={formInputs?.premiumPaidDate}
                                                        dateFormat='dd MMM, yyyy'
                                                        showTimeSelect={false}
                                                        flag = 'premiumPaidDate'
                                                        maxDate={new Date()} 
                                                        
                                                    />
                                                    {errField.premiumPaidDate && (
                                                        <span className="error-txt">
                                                            {errField['premiumPaidDate']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.paymentReferenceNo}>
                                                    <input value={formInputs.paymentReferenceNo} onChange={(e: any) => onChangeHandler(e.target.value, 'paymentReferenceNo')} id="" type="text" placeholder=" " name="paymentReferenceNo" className="form-input"/>
                                                    <label data-label= {`${translations.Insurance?.['Payment Reference No'] || translations.commonMsg?.loading}`}className="form-label"></label>
                                                    {/* { errField.paymentReferenceNo && (
                                                        <span className="error-txt">
                                                            {errField['paymentReferenceNo']}
                                                        </span>
                                                    )} */}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.transactionFeePaidByCustomer}>
                                                <input spellCheck={false}
                                                        value={getDisplayValue('transactionFeePaidByCustomer',formInputs.transactionFeePaidByCustomer)} 
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                            onChangeHandler(getNumericValue('transactionFeePaidByCustomer',e.target.value), 'transactionFeePaidByCustomer')
                                                        } 
                                                        id="" 
                                                        type="text" 
                                                        placeholder=" " 
                                                        name="transactionFeePaidByCustomer" 
                                                        className="form-input" 
                                                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                                            if (e.key === "e" || e.key === "E" || e.key === "." || e.key === "-") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    <label data-label= {`${translations.Insurance?.['Transaction Fee Paid by Customer'] || translations.commonMsg?.loading}`} className="form-label"></label>
                                                    {/* {errField.transactionFeePaidByCustomer && (
                                                        <span className="error-txt">
                                                            {errField['transactionFeePaidByCustomer']}
                                                        </span>
                                                    )} */}
                                                </div>
                                            </fieldset>
                                        </>
                                    }
                                </>
                            }
                            {
                                formType === "incentive-payment" &&
                                <>
                                    <ReactSelect options={paymentTo} value={formShowType} placeholder={`${translations.Insurance?.['Payment From'] || translations.commonMsg?.loading} *`} fieldKey="paymentTo" handleChange={(e: any, fieldKey: string) => onChangeFormType(e, fieldKey)} errorField={errField.paymentTo} fieldSetClassName="col-md-12" isDisabled={true}/>
                                    {
                                        formShowType &&
                                        <>
                                            {
                                                formShowType.value === FORM_SOW_TYPE['CUSTOMER'] &&
                                                <>
                                                    <fieldset className="col-md-6">
                                                        <div className="material" title = {formInputs.commission}>
                                                            <input value={formInputs.commission} onChange={(e: any) => onChangeHandler(e.target.value, 'commission')} id="" type="text" placeholder=" " name="commission" className="form-input" disabled/>
                                                            <label data-label={`${translations.Insurance?.['Commission (%)'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                            {errField.commission && (
                                                                <span className="error-txt">
                                                                    {errField['commission']}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </fieldset>
                                                    <fieldset className="col-md-6">
                                                        <div className="material" title = {formInputs.commissionValue}>
                                                            <input spellCheck={false} value={getDisplayValue('commissionValue',formInputs.commissionValue)}onChange={(e: any) => onChangeHandler(getNumericValue('commissionValue',e.target.value), 'commissionValue')} id="" type="text" placeholder=" " name="commissionValue" className="form-input" disabled/>
                                                            <label data-label={`${translations.Insurance?.['Commission Value'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                            {errField.commissionValue && (
                                                                <span className="error-txt">
                                                                    {errField['commissionValue']}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </fieldset>
                                                    <fieldset className="col-md-6">
                                                        <div className="material" title = {formInputs.cus_taxcommission}>
                                                            <input spellCheck={false} value={getDisplayValue('cus_taxcommission',formInputs.cus_taxcommission)} onChange={(e: any) => onChangeHandler(getNumericValue('cus_taxcommission',e.target.value), 'cus_taxcommission')} id="" type="text" placeholder=" " name="cus_taxcommission" className="form-input" disabled/>
                                                            <label data-label={`${translations.Insurance?.['Tax Commission'] || translations.commonMsg?.loading} *`} className="form-label"></label> 
                                                        </div>
                                                    </fieldset>
                                                    <fieldset className="col-md-6">
                                                        <div className="material" title = {formInputs.netCommissionDisbursal}>
                                                            <input spellCheck={false} value={getDisplayValue('cus_netcommissiondisbursal',formInputs.cus_netcommissiondisbursal)} onChange={(e: any) => onChangeHandler(getNumericValue('cus_netcommissiondisbursal',e.target.value), 'cus_netcommissiondisbursal')} id="" type="text" placeholder=" " name="cus_netcommissiondisbursal" className="form-input" disabled/>
                                                            <label data-label={`${translations.Insurance?.['Net_Commission_Disbursal'] || translations.commonMsg?.loading} *`} className="form-label"></label> 
                                                        </div>
                                                    </fieldset>
                                                </>
                                            }
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.points}>
                                                    <input  value={formInputs.points} onChange={(e: any) => onChangeHandler(e.target.value, 'points')} id="" type="text" placeholder=" " name="points" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Points (%)'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.points && (
                                                        <span className="error-txt">
                                                            {errField['points']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.pointsValue}>
                                                    <input spellCheck={false} value={getDisplayValue('pointsValue',formInputs.pointsValue)} onChange={(e: any) => onChangeHandler(getNumericValue('pointsValue',e.target.value), 'pointsValue')} id="" type="text" placeholder=" " name="pointsValue" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Points Value'] || translations.commonMsg?.loading} *`}className="form-label"></label>
                                                    {errField.pointsValue && (
                                                        <span className="error-txt">
                                                            {errField['pointsValue']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.taxCommission}>
                                                    <input spellCheck={false} value={getDisplayValue('taxCommission',formInputs.taxCommission)} onChange={(e: any) => onChangeHandler(getNumericValue('taxCommission',e.target.value), 'taxCommission')} id="" type="text" placeholder=" " name="taxCommission" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Tax_Points'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.taxCommission && (
                                                        <span className="error-txt">
                                                            {errField['taxCommission']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                            <fieldset className="col-md-6">
                                                <div className="material" title = {formInputs.netCommissionDisbursal}>
                                                    <input spellCheck={false} value={getDisplayValue('netCommissionDisbursal',formInputs.netCommissionDisbursal)} onChange={(e: any) => onChangeHandler(getNumericValue('netCommissionDisbursal',e.target.value), 'netCommissionDisbursal')} id="" type="text" placeholder=" " name="netCommissionDisbursal" className="form-input" disabled/>
                                                    <label data-label={`${translations.Insurance?.['Net Commission Disbursal'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                    {errField.netCommissionDisbursal && (
                                                        <span className="error-txt">
                                                            {errField['netCommissionDisbursal']}
                                                        </span>
                                                    )}
                                                </div>
                                            </fieldset>
                                              {
                                                COUNTRY_CODE === 'id' &&
                                                  <>
                                                      {insuranceState?.leadDetail?.lead_type === LEAD_TYPE_CRM &&
                                                          <>
                                                              <fieldset className="col-md-6">
                                                                  <div className="material" title={formInputs.cash_customer_per}>
                                                                      <input value={formInputs.cash_customer_per} onChange={(e: any) => onChangeHandler(e.target.value, 'cash_customer_per')} id="" type="text" placeholder=" " name="netCommissionDisbursal" className="form-input" disabled />
                                                                      <label data-label={`${translations.Insurance?.['Customer Cashback %'] || translations.commonMsg?.loading}`} className="form-label"></label>
                                                                      {errField.cash_customer_per && (
                                                                          <span className="error-txt">
                                                                              {errField['cash_customer_per']}
                                                                          </span>
                                                                      )}
                                                                  </div>
                                                              </fieldset>
                                                              <fieldset className="col-md-6">
                                                                  <div className="material" title={formInputs.cash_customer}>
                                                                      <input spellCheck={false} value={getDisplayValue('cash_customer',formInputs.cash_customer)} onChange={(e: any) => onChangeHandler(getNumericValue('cash_customer',e.target.value), 'cash_customer')} id="" type="text" placeholder=" " name="netCommissionDisbursal" className="form-input" disabled />
                                                                      <label data-label={`${translations.Insurance?.['Customer Cashback'] || translations.commonMsg?.loading}`} className="form-label"></label>
                                                                      {errField.cash_customer && (
                                                                          <span className="error-txt">
                                                                              {errField['cash_customer']}
                                                                          </span>
                                                                      )}
                                                                  </div>
                                                              </fieldset>
                                                          </>
                                                      }

                                                      <fieldset className="col-md-6">
                                                          <div className="material" title={formInputs.gross_profit}>
                                                              <input spellCheck={false} value={formInputs.gross_profit} onChange={(e: any) => onChangeHandler(e.target.value, 'gross_profit')} id="" type="text" placeholder=" " name="netCommissionDisbursal" className="form-input" disabled />
                                                              <label data-label={`${translations.Insurance?.[`OTO's Profit (%)`] || translations.commonMsg?.loading}`} className="form-label"></label>
                                                              {errField.gross_profit && (
                                                                  <span className="error-txt">
                                                                      {errField['gross_profit']}
                                                                  </span>
                                                              )}
                                                          </div>
                                                      </fieldset>
                                                      <fieldset className="col-md-6">
                                                          <div className="material" title={formInputs.transferFee}>
                                                              <input spellCheck={false} value={getDisplayValue('transferFee',formInputs.transferFee)} onChange={(e: any) => onChangeHandler(getNumericValue('transferFee',e.target.value), 'transferFee')} id="" type="text" placeholder=" " name="transferFee" className="form-input" />
                                                              <label data-label={`${translations.Insurance?.['Bank Transfer Fee'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                                              {errField.transferFee && (
                                                                  <span className="error-txt">
                                                                      {errField['transferFee']}
                                                                  </span>
                                                              )}
                                                          </div>
                                                      </fieldset>
                                                      <fieldset className="col-md-6">
                                                          <div className={(formInputs?.earningsPaymentDate) ? "active-label material animation-effect" : "material animation-effect "}>
                                                              <ExpiryEffectivityDate
                                                                  onChange={(e: Date) => onChangeHandler(e, 'earningsPaymentDate')}
                                                                  placeholder=""
                                                                  text={`${translations.Insurance?.['EARNINGS_PAYMENT_DATE'] || translations.commonMsg?.loading} *`}
                                                                  insurancePolicyDate={formInputs?.earningsPaymentDate}
                                                                  dateFormat='dd MMM, yyyy'
                                                                  showTimeSelect={false}
                                                                  flag='earningsPaymentDate'
                                                              />
                                                              {errField.earningsPaymentDate && (
                                                                  <span className="error-txt">
                                                                      {errField['earningsPaymentDate']}
                                                                  </span>
                                                              )}
                                                          </div>
                                                      </fieldset>
                                                  </>
                                              }
                                              
                                        </>
                                    }
                                </>
                            }
                        </div>


                    </div>

                    {formType === "insurance-premium-payment" && 
                        <DocumentForm docTypeId={[DOCUMENT_CATEGORY['postDisbursal']['doc_type_id']]} docId={(formType === 'insurance-premium-payment') ? [DOCUMENT_CATEGORY['postDisbursal']['childs']['insurance_premium_payment']] : [DOCUMENT_CATEGORY['disbursal']['childs']['policy_shared']]} formType={props.formType} resolveFileUpload={resolveFileUpload} submitClicked={submitClicked} errField={errField} updatedFileCount={updatedFileCount}  />
                    }

                    <div className="btn-save-remarks m-xl-t">
                        {
                            HELPER.isUserHasUpdateAccess({ permissionID: (formType === 'insurance-premium-payment' ? ROLE_FEATURES['insurance_premium_payment'] : ROLE_FEATURES['incentive-payment']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: formType })

                                ?
                                <button type="button" className="btn-primary" onClick={saveInsurancePremiumPayment}>{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</button>
                                :
                                <button type="button" className="btn-primary" disabled>{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</button>

                        }
                        <LeadRemarksButton leadId={queryParams.id} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InsurancePremiumPayment;